import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_DrugMonitoringForm = ({ itemsRef, showErrorFor }) => {
    {/*write name of assessment inplace of "Assessment_Name"*/ }

    return <form id='GHP_DrugMonitoringForm' className='file-pdf-document'> {/*write name of assessment inplace of "Assessment_Name"*/}
        <div className='file-template'>

            {/* Start HTML code from here */}

            <h3>Acknowledgement of
                Prescription Drug Monitoring
            </h3>
            <p className='flexData'>
                I <input className='add-only w-375' type="text" name="txtName" id="txtName" /> <span className='view-only txtName'></span>acknowledge and understand that over the course of my treatment at Georgia Health Partners, the physicians of Georgia Health Partners access and reviews prescription history via the Prescription Drug Monitoring Program; by visiting www.georgia.pmpaware.net/login.

            </p>
            <p>
                I understand that this access allows the physicians to increase safety measures when prescribing psychotropic medications while under their care.
            </p>
            <p>
                Any changes in medications, physician will submit a medication consents form to the provider agency.
            </p>
            <p>
                Any prescription refill requests shall be made at least 10 business days prior to running out of medications.
            </p>
            <p>
                <input type="checkbox" name="cbTelehealth" id="cbTelehealth" className="add-only" value="Telehealth" />
                <strong>Due to COVID 19 and the use of telehealth, a verbal consent was obtained.</strong>
            </p>

            {/* HTML code end here */}


        </div>
    </form >
}